export interface PartnerSite {
  /** Name of the program, school, clinic, or project on the ground */
  name: string
  nameEs?: string
  /** Human-readable place, e.g. 'San Pedro Sula, Honduras' */
  location: string
  /** [latitude, longitude] of the field site */
  coords: [number, number]
}

export interface SisterOrganization {
  name: string
  location: string
  focus: string
  focusEs: string
  description: string
  descriptionEs: string
  url?: string
  /** [latitude, longitude] of the organization's primary base */
  coords: [number, number]
  /** Hex accent used for the map pin and the card's top stripe */
  accent: string
  /**
   * Optional site in Honduras (or elsewhere) where this organization works.
   * When present, the map draws a dashed link between the two points and the
   * organization's popup offers a "See their work in ..." action that zooms
   * to show both the U.S. base and the field site together.
   */
  partnerSite?: PartnerSite
}

/**
 * Participating organizations in the Honduran-American National Network.
 *
 * Add each organization as it joins — every entry automatically appears both
 * as a pin on the network map and as a row in the directory.
 *
 * Template:
 * {
 *   name: 'CRC — We Care We Share',
 *   location: 'New Orleans, LA',
 *   focus: 'Community Services',
 *   focusEs: 'Servicios Comunitarios',
 *   description: 'One or two sentences about the organization.',
 *   descriptionEs: 'Una o dos oraciones sobre la organización.',
 *   url: 'https://www.crcwecareweshare.org/',
 *   coords: [29.9511, -90.0715],
 *   accent: '#1565C0',
 *   partnerSite: {
 *     name: 'Community Programs',
 *     nameEs: 'Programas Comunitarios',
 *     location: 'San Pedro Sula, Honduras',
 *     coords: [15.5041, -88.025],
 *   },
 * }
 */
export const SISTER_ORGANIZATIONS: SisterOrganization[] = []
